import messages from '../tag-messages.js';
export default [
    { tag: '动物', intlLabel: messages.animals },
    { tag: '人物', intlLabel: messages.people },
    { tag: '物品', intlLabel: { defaultMessage: "物品", id: "null" } },
    { tag: '文字', intlLabel: { defaultMessage: "文字", id: "null" } },
    { tag: '数字', intlLabel: messages.numbers },
    { tag: '场景', intlLabel: { defaultMessage: "场景", id: "null" } },
    { tag: '按钮', intlLabel: { defaultMessage: "按钮", id: "null" } },
    { tag: '其他', intlLabel: { defaultMessage: "其他", id: "null" } },
];
